import { Injectable, effect, inject } from '@angular/core';
import {
  FarmScope,
  FarmScopeSelectors,
  FarmScopeState,
} from '@cropx-web/state/farm-scope.state';
import { FarmsSelectors } from '@cropx-web/state/farms.state';
import { Store, select } from '@ngxs/store';
import dayjs from 'dayjs';
import { StateReset } from 'ngxs-reset-plugin';

@Injectable({ providedIn: 'root' })
export class FarmScopeService {
  private store = inject(Store);

  farms = select(FarmsSelectors.slices.farms);
  farmUuid = select(FarmScopeSelectors.slices.farmUuid);
  fields = select(FarmScopeSelectors.slices.fields);
  farmCenter = select(FarmScopeSelectors.farmCenter);
  timeZone = select(FarmScopeSelectors.timezone);

  constructor() {
    effect(() => {
      const farmUuid = this.farmUuid();
      if (farmUuid) {
        return;
      }
      const farms = this.farms();
      if (!farms.length) {
        return;
      }

      const farm = farms.find((f) => f.uuid === farmUuid);
      if (!farm && farmUuid) {
        console.error(
          'Switching to a farm that the user does not have access to! (farmUuid: %s)',
          farmUuid,
        );
      }
    });

    effect(() => {
      const farmUuid = this.farmUuid();

      if (farmUuid) {
        this.store.dispatch(new FarmScope.FetchCropZones(farmUuid));
        this.store.dispatch(new FarmScope.FetchFields(farmUuid));
        this.store.dispatch(new FarmScope.FetchRecords(farmUuid));
      } else {
        this.store.dispatch(new StateReset(FarmScopeState));
      }
    });

    effect(() => {
      const farmCenter = this.farmCenter();
      if (farmCenter) {
        const start = dayjs().startOf('day').tz(this.timeZone(), true);
        const end = dayjs()
          .endOf('day')
          .tz(this.timeZone(), true)
          .add(6, 'days');

        start.toDate();

        this.store.dispatch(
          new FarmScope.FetchDailyWeather(
            farmCenter.coordinates[1],
            farmCenter.coordinates[0],
            start.format('YYYY-MM-DD'),
            end.format('YYYY-MM-DD'),
          ),
        );
        this.store.dispatch(
          new FarmScope.FetchWeather(
            farmCenter.coordinates[1],
            farmCenter.coordinates[0],
            start.format('YYYY-MM-DD'),
            end.format('YYYY-MM-DD'),
          ),
        );
      }
    });
  }
}
